export default __webpack_public_path__ + "static/media/qb_remove_item.723dcc94.svg";